import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";

const editExperienceSuccess = createLogic({
	type: ActionTypes.EDIT_EXPERIENCE_SUCCESS,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ExperiencesActions.loadExperiences());
		done();
	},
});

export default [editExperienceSuccess];
